module.exports = __webpack_public_path__ + "static/media/ZCMD02.3f1e1ba4.jpg";